export default "__VITE_ASSET__0d0939b5__"